/**
 * 내정보 (/m/setting/my) — 프로필 사진·비밀번호 보기·본인인증·소셜 연동·탈퇴 진입·회원유형 변경
 * ($j.Pages.Mobile.SettingMy / body data-page-name="SettingMy")
 *
 * 구 public/js/m-my.js (전역 함수 묶음)를 옮긴 것. window.inicisCallback 은 이니시스 인증 창이 부르는 약속이라 window 에 둔다.
 */
export default class SettingMy {
    initialize() {
        // 본인인증 생략(개발 서버) — F/Inicis 가 G5['inicisByPass'] 를 본다 (#page-data)
        G5['inicisByPass'] = JSON.parse(document.getElementById('page-data')?.textContent || '{}').inicisByPass;
        window.inicisCallback = inicisCallback;

        $('.smy-avatar').on('click', addphotoHere);
        initPage();
        initHandler();
    }
}

/**
 * 프로필 사진 변경 — 앱 네이티브 피커(addPhotoHere).
 *
 * 디바이스 사진 격자(pickPhotos)는 쓰지 않는다 — 격자는 **모바일 일지**(현장사진·작업문서)
 * 전용이다(F/Upload.pickPhotos 머리말). 프로필은 한 장을 고르는 일이라 격자가 벌어 주는 것도 없다.
 *
 * 업로드 결과는 아래 'upload:image' 구독(context 'memberProfile')이 받아 updateProfile() 로
 * 처리한다 — 격자를 쓰던 때와 같은 자리다.
 */
function addphotoHere(){
    $j.F.Upload.addPhotoHere({ tag: 'profile', context: 'memberProfile', max_sheet: 1 });
}
/**
 * 파일 업로드 후 비즈니스로직
 * @param file
 */
function updateProfile(file){
    // alert(JSON.stringify(file));
    if( Array.isArray(file)) file=file[0];
    $.ajax({
        type: 'POST',
        url: `/m/ajax/member/profile-image`,
        data: file,
        success: function (r) {
            // alert(JSON.stringify(r));
            if( r.result !== true){
                $j.Common.Util.tsalert('warning','처리중 오류가 발생하였습니다.');
                return;
            }
            location.reload();
        }
    });
}

// 구 uploadDone() (앱 카메라 업로드 완료 시 앱이 직접 호출) 은 2026-08 제거.
// 업로드 완료는 broker 콜백 callbackUploadImage → EventBus 'upload:image' 로 받는다.
// pw 아이콘 토글
function pwIconToggleHandler(){
    $('.eyes').on('click keydown', function(e){
        // 키보드 접근(Enter/Space) 허용
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();

        const $btn   = $(this);
        const $input = $btn.prev('input');
        const show   = $input.attr('type') === 'password'; // 보이기 여부

        $input.attr('type', show ? 'text' : 'password');

        // 아이콘/라벨 토글
        $btn.attr({
            'aria-pressed': String(show),
            'aria-label'  : show ? '비밀번호 숨기기' : '비밀번호 보기'
        });
        $btn.find('i').toggleClass('fa-eye fa-eye-slash');
    });
}

function initPage(){
    // 앱 버전·업데이트 버튼은 환경설정(/m/setting/env)으로 옮겼다 — 여기서 하던 v1/v2 비교도 함께 갔다.
}

function initHandler(){
    pwIconToggleHandler()

    $j.Common.EventBus.on(G5['NS'], 'upload:image', function(e, payload){
        if( $j.F.Upload.getContext() !== 'memberProfile') return;
        updateProfile(payload);
    });

    // 회원 탈퇴 버튼 클릭 시
    $('.leave_btn').on('click', function (e) {
        e.preventDefault(); // 기본 동작 막기

        $j.Common.Util.loadingOverlay(true);
        $.ajax({
            type: 'POST',
            url: '/m/ajax/member/leave/check',
            success: function (res) {
                $j.Common.Util.loadingOverlay(false);
                if (!res.result) {
                    // 이미 탈퇴 요청한 경우
                    location.href = '/m/member/wait';
                    return;
                }

                const soojoo_hold = res.info['수주홀드금액'];
                const baljoo_hold = res.info['발주홀드금액'];
                const soobal_cnt = res.info['진행중오더개수'];

                if (soojoo_hold + baljoo_hold > 0 || soobal_cnt > 0) {
                    leaveBlockModal(soobal_cnt, soojoo_hold, baljoo_hold);
                } else {
                    // 본인인증이 된 회원이면 인증을 받게 한다.
                    if( MEMBER['real_name'] ){
                        startInicis('leave'); // 이니시스 인증창 띄우기
                    }
                    // 본인인증 안된 회원이면
                    else{
                        leaveModal();
                    }
                }
            },
            error: function () {
                $j.Common.Util.swalert('서버 오류가 발생했습니다');
            }
        });
    });

    // 본인인증 버튼 — 이니시스 인증창을 띄운다.
    // 화면에서 id 가 사라진 뒤로도 셀렉터가 #inicis-auth 로 남아 있어 버튼이 아무 동작도 하지 않았다.
    // 성공하면 inicisCallback('real') 이 reload → 소셜 연동 줄이 그려진다.
    $('.js-inicis-auth').on('click', function () {
        startInicis('real');
    });

    // 소셜 로그인 연동 스위치.
    // 켜진 상태(=소셜로 만든 계정)는 끌 수 없다 — 끊으면 이 회원의 로그인 수단이 사라진다.
    $('.smy-sw').on('click', function () {
        const $sw = $(this);
        if (Number($sw.data('locked')) === 1) {
            $j.Common.Util.swalert('연결된 소셜 계정은 앱에서 해제할 수 없습니다.\n고객센터로 문의해 주세요.');
            return;
        }
        $j.F.Social.login($sw.data('value'));
    });

    // 카드 안내문 ⓘ 아코디언 (계좌 카드)
    $('.smy-help-btn').on('click', function () {
        const open = $(this).attr('aria-expanded') !== 'true';
        $(this).attr('aria-expanded', String(open));
        $(this).closest('.jb-card').find('.smy-note').toggleClass('is-open', open);
    });

    // 비번변경 — 모달($j.F.Mobile.ModalPassword)에서 화면(/m/setting/password)으로 옮겼다.
    // 안드로이드 백버튼 대응상 replace 가 아니라 이동이다 — ✕/뒤로가 내정보로 돌아와야 한다.
    $('#change-password').on('click', function () {
        location.href = '/m/setting/password';
    });

    // 회원유형변경
    $('#change-driver-type-btn').on('click', function () {
        $j.F.Member.ModalCarOption.changeDriverType();
    });
}

/**
 * 이니시스 인증 호출
 */
function startInicis(type){
    const callbackUrl = $j.Common.Util.getHost()+`/m/plugin/inicis/callback/${type}`;
    $j.F.Inicis.auth({
        'successUrl': callbackUrl,
        'failUrl': callbackUrl,
        type
    });
}

/**
 * 이니시스 콜백
 * @param data
 */
function inicisCallback(data){
    if(!data.result){
        $j.Common.Util.swalert(data.message);
        return;
    }
    if( data.type == 'real' ){
        $j.Common.Util.swalert('인증이 완료되었습니다.', function(){
            location.reload();
        });
    } else if(data.type == 'leave'){
        $j.Common.Util.swalert('인증이 완료되었습니다.', function(){
            goLeavePage();
        });
    }
}
// 탈퇴페이지로 이동
function goLeavePage(){
    location.href = '/m/member/leave';
}

// 즉시탈퇴 불가 안내 모달
function leaveBlockModal(soobalCnt, soojooHold, baljooHold){
    let rows = '';
    if (soobalCnt > 0) {
        rows += `<div class="lvb-row">
            <span class="lvb-label">진행중인 수주/발주건</span>
            <span class="lvb-val">${soobalCnt}건</span>
        </div>`;
    }
    if (soojooHold + baljooHold > 0) {
        rows += `<div class="lvb-row">
            <span class="lvb-label">홀드캐시 (수주/발주)</span>
            <span class="lvb-val">${$j.Common.Util.formatNumber(soojooHold)}P / ${$j.Common.Util.formatNumber(baljooHold)}P</span>
        </div>`;
    }

    const html = `
        <div class="lvb-wrap">
            <div class="lvb-head">
                <p class="lvb-title">즉시탈퇴가 <b>불가능</b>합니다</p>
                <p class="lvb-desc">아래 사유를 완료하신 후 다시 진행해 주세요.</p>
            </div>
            <div class="lvb-card">${rows}</div>
            <div class="lvb-btns">
                <button type="button" class="lvb-btn lvb-btn-primary" data-act="close">확인</button>
            </div>
        </div>
    `;

    $j.Ui.Modal.open({
        title: '회원탈퇴',
        html,
        mode: 'center',
        width: '420px',
        onOpen: (h) => {
            h.el.find('[data-act="close"]').on('click', h.close);
        },
    });
}

// 탈퇴 모달
function leaveModal(){
    const html = `
    <div class="modal_pw_ch">
            <h2>회원탈퇴</h2>

            <p>안전한 탈퇴 진행을 위해 비밀번호를 입력해주세요</p>

            <div class="pw_box1">
                <h4>현재비밀번호</h4>
                <div class="input_box">
                    <input type="password" id="passCheck" placeholder="현재 비밀번호를 입력해주세요">
                    <div class="eyes" aria-label="비밀번호 보기" aria-pressed="false"><i class="fas fa-eye-slash"></i></div>
                </div>
            </div>

            <div class="btn_box">
                <button type="button" class="off" id="nextStepBtn">다음단계</button>
            </div>
        </div>
    `;
    $j.Common.Util.modal(html);
    pwIconToggleHandler();

    // 회원탈퇴 비밀번호 입력시
    $('#passCheck').on('input', function () {
        var pw = $(this).val();
        var $btn = $('#nextStepBtn');

        if (pw.length >= 4) {
            $btn.removeClass('off').addClass('on');
        } else {
            $btn.removeClass('on').addClass('off');
        }
    });

    // 탈퇴 비밀번호 확인 모달에서 다음 버튼 클릭 시
    $('#nextStepBtn').on('click', function () {
        const password = $('#passCheck').val();
        if (!password) {
            // $('#pwAlert').text('비밀번호를 입력해주세요').show();
            $j.Common.Util.tsalert('warning','비밀번호를 입력해주세요');
            return;
        }

        $.ajax({
            type: 'POST',
            url: '/m/ajax/member/password/check',
            data: { password: password },
            success: function (res) {
                if (!res.result) {
                    $j.Common.Util.tsalert('warning',res.message);
                    return;
                }
                // 비밀번호 맞으면 페이지 이동
                goLeavePage();
            },
        });
    });
}
